var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliverIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:delivery-truck"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.52922 10.1644L3.21422 6.9594C3.35922 6.6844 3.64422 6.5144 3.95422 6.5144H7.37422C7.39411 6.5144 7.41319 6.52231 7.42725 6.53637C7.44132 6.55044 7.44922 6.56951 7.44922 6.5894V11.4829L1.44922 10.5594C1.44922 10.4244 1.47422 10.2894 1.52922 10.1644Z",
    fill: "url(#paint0_linear_458_784)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.52922 10.1644L3.21422 6.9594C3.35922 6.6844 3.64422 6.5144 3.95422 6.5144H7.37422C7.39411 6.5144 7.41319 6.52231 7.42725 6.53637C7.44132 6.55044 7.44922 6.56951 7.44922 6.5894V11.4829L1.44922 10.5594C1.44922 10.4244 1.47422 10.2894 1.52922 10.1644Z",
    fill: "url(#paint1_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.52922 10.1644L3.21422 6.9594C3.35922 6.6844 3.64422 6.5144 3.95422 6.5144H7.37422C7.39411 6.5144 7.41319 6.52231 7.42725 6.53637C7.44132 6.55044 7.44922 6.56951 7.44922 6.5894V11.4829L1.44922 10.5594C1.44922 10.4244 1.47422 10.2894 1.52922 10.1644Z",
    fill: "url(#paint2_linear_458_784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.9492 4.0144H8.94922C8.11922 4.0144 7.44922 4.6844 7.44922 5.5144V11.1399H15.4492V5.5149C15.4492 4.6849 14.7792 4.0149 13.9492 4.0149",
    fill: "url(#paint3_linear_458_784)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9492 4.0144H8.94922C8.11922 4.0144 7.44922 4.6844 7.44922 5.5144V11.1399H15.4492V5.5149C15.4492 4.6849 14.7792 4.0149 13.9492 4.0149",
    fill: "url(#paint4_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.9492 4.0144H8.94922C8.11922 4.0144 7.44922 4.6844 7.44922 5.5144V11.1399H15.4492V5.5149C15.4492 4.6849 14.7792 4.0149 13.9492 4.0149",
    fill: "url(#paint5_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1.604 10.0143H4.899C5.204 10.0143 5.449 9.76929 5.449 9.46429V7.56929C5.449 7.26429 5.204 7.01929 4.899 7.01929H3.189L1.604 10.0143Z",
    fill: "url(#paint6_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M1.604 10.0143H4.899C5.204 10.0143 5.449 9.76929 5.449 9.46429V7.56929C5.449 7.26429 5.204 7.01929 4.899 7.01929H3.189L1.604 10.0143Z",
    fill: "url(#paint7_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M1.604 10.0143H4.899C5.204 10.0143 5.449 9.76929 5.449 9.46429V7.56929C5.449 7.26429 5.204 7.01929 4.899 7.01929H3.189L1.604 10.0143Z",
    fill: "url(#paint8_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.44922 14.017V10.512H15.4492V13.117C15.4492 13.612 15.0442 14.017 14.5492 14.017H7.44922Z",
    fill: "url(#paint9_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M7.44922 14.017V10.512H15.4492V13.117C15.4492 13.612 15.0442 14.017 14.5492 14.017H7.44922Z",
    fill: "url(#paint10_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.44922 14.017V10.512H15.4492V13.117C15.4492 13.612 15.0442 14.017 14.5492 14.017H7.44922Z",
    fill: "url(#paint11_linear_458_784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.1992 14.5144C12.3981 14.5144 12.5889 14.4354 12.7295 14.2947C12.8702 14.1541 12.9492 13.9633 12.9492 13.7644C12.9492 13.5655 12.8702 13.3747 12.7295 13.2341C12.5889 13.0934 12.3981 13.0144 12.1992 13.0144C12.0003 13.0144 11.8095 13.0934 11.6689 13.2341C11.5282 13.3747 11.4492 13.5655 11.4492 13.7644C11.4492 13.9633 11.5282 14.1541 11.6689 14.2947C11.8095 14.4354 12.0003 14.5144 12.1992 14.5144Z",
    fill: "#D9C3F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.4491 11.5144H15.1991C14.7741 11.5144 14.4291 11.8694 14.4491 12.2994C14.4691 12.7044 14.8191 13.0144 15.2241 13.0144H15.4491V11.5144Z",
    fill: "url(#paint12_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.44922 10.5144H1.44922V13.1294C1.44922 13.6194 1.84922 14.0194 2.33922 14.0194H7.44922V10.5144Z",
    fill: "url(#paint13_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.44922 10.5144H1.44922V13.1294C1.44922 13.6194 1.84922 14.0194 2.33922 14.0194H7.44922V10.5144Z",
    fill: "url(#paint14_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.44922 10.5144H1.44922V13.1294C1.44922 13.6194 1.84922 14.0194 2.33922 14.0194H7.44922V10.5144Z",
    fill: "url(#paint15_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M7.44922 10.5144H1.44922V13.1294C1.44922 13.6194 1.84922 14.0194 2.33922 14.0194H7.44922V10.5144Z",
    fill: "url(#paint16_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73976 14.0194C6.77584 13.7434 6.7526 13.4629 6.67162 13.1966C6.59063 12.9303 6.45376 12.6843 6.27013 12.4751C6.08651 12.2659 5.86037 12.0983 5.60681 11.9835C5.35325 11.8687 5.07811 11.8093 4.79976 11.8093C4.52142 11.8093 4.24628 11.8687 3.99272 11.9835C3.73916 12.0983 3.51301 12.2659 3.32939 12.4751C3.14577 12.6843 3.00889 12.9303 2.92791 13.1966C2.84692 13.4629 2.82369 13.7434 2.85976 14.0194H6.73976Z",
    fill: "url(#paint17_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1392 14.0194C14.1752 13.7434 14.152 13.4629 14.071 13.1966C13.99 12.9303 13.8532 12.6843 13.6695 12.4751C13.4859 12.2659 13.2598 12.0983 13.0062 11.9835C12.7527 11.8687 12.4775 11.8093 12.1992 11.8093C11.9208 11.8093 11.6457 11.8687 11.3921 11.9835C11.1386 12.0983 10.9124 12.2659 10.7288 12.4751C10.5452 12.6843 10.4083 12.9303 10.3273 13.1966C10.2463 13.4629 10.2231 13.7434 10.2592 14.0194H14.1392Z",
    fill: "url(#paint18_linear_458_784)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.2135 15.4998C12.6738 15.4998 13.1152 15.317 13.4407 14.9915C13.7662 14.666 13.949 14.2246 13.949 13.7643C13.949 13.304 13.7662 12.8626 13.4407 12.5371C13.1152 12.2117 12.6738 12.0288 12.2135 12.0288C11.7532 12.0288 11.3118 12.2117 10.9863 12.5371C10.6609 12.8626 10.478 13.304 10.478 13.7643C10.478 14.2246 10.6609 14.666 10.9863 14.9915C11.3118 15.317 11.7532 15.4998 12.2135 15.4998Z",
    fill: "url(#paint19_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M12.2135 15.4998C12.6738 15.4998 13.1152 15.317 13.4407 14.9915C13.7662 14.666 13.949 14.2246 13.949 13.7643C13.949 13.304 13.7662 12.8626 13.4407 12.5371C13.1152 12.2117 12.6738 12.0288 12.2135 12.0288C11.7532 12.0288 11.3118 12.2117 10.9863 12.5371C10.6609 12.8626 10.478 13.304 10.478 13.7643C10.478 14.2246 10.6609 14.666 10.9863 14.9915C11.3118 15.317 11.7532 15.4998 12.2135 15.4998Z",
    fill: "url(#paint20_radial_458_784)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M12.2152 14.405C12.3851 14.405 12.548 14.3375 12.6681 14.2174C12.7882 14.0973 12.8557 13.9344 12.8557 13.7645C12.8557 13.5947 12.7882 13.4317 12.6681 13.3116C12.548 13.1915 12.3851 13.124 12.2152 13.124C12.0453 13.124 11.8824 13.1915 11.7623 13.3116C11.6422 13.4317 11.5747 13.5947 11.5747 13.7645C11.5747 13.9344 11.6422 14.0973 11.7623 14.2174C11.8824 14.3375 12.0453 14.405 12.2152 14.405Z",
    fill: "#D9C3F0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M1.90422 13.0144H1.44922V11.0144H1.90422C2.20422 11.0144 2.44922 11.2594 2.44922 11.5594V12.4694C2.44922 12.7694 2.20422 13.0144 1.90422 13.0144Z",
    fill: "#F8DA4B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M4.79995 15.4998C5.26024 15.4998 5.70167 15.317 6.02714 14.9915C6.35261 14.666 6.53545 14.2246 6.53545 13.7643C6.53545 13.304 6.35261 12.8626 6.02714 12.5371C5.70167 12.2117 5.26024 12.0288 4.79995 12.0288C4.33967 12.0288 3.89824 12.2117 3.57277 12.5371C3.2473 12.8626 3.06445 13.304 3.06445 13.7643C3.06445 14.2246 3.2473 14.666 3.57277 14.9915C3.89824 15.317 4.33967 15.4998 4.79995 15.4998Z",
    fill: "url(#paint21_linear_458_784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M4.79995 15.4998C5.26024 15.4998 5.70167 15.317 6.02714 14.9915C6.35261 14.666 6.53545 14.2246 6.53545 13.7643C6.53545 13.304 6.35261 12.8626 6.02714 12.5371C5.70167 12.2117 5.26024 12.0288 4.79995 12.0288C4.33967 12.0288 3.89824 12.2117 3.57277 12.5371C3.2473 12.8626 3.06445 13.304 3.06445 13.7643C3.06445 14.2246 3.2473 14.666 3.57277 14.9915C3.89824 15.317 4.33967 15.4998 4.79995 15.4998Z",
    fill: "url(#paint22_radial_458_784)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_ii_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M4.80066 14.405C4.97053 14.405 5.13344 14.3375 5.25356 14.2174C5.37367 14.0973 5.44116 13.9344 5.44116 13.7645C5.44116 13.5947 5.37367 13.4317 5.25356 13.3116C5.13344 13.1915 4.97053 13.124 4.80066 13.124C4.63078 13.124 4.46787 13.1915 4.34775 13.3116C4.22764 13.4317 4.16016 13.5947 4.16016 13.7645C4.16016 13.9344 4.22764 14.0973 4.34775 14.2174C4.46787 14.3375 4.63078 14.405 4.80066 14.405Z",
    fill: "#D9C3F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_f_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M4.87819 14.7925C5.5401 14.7925 6.07669 14.2559 6.07669 13.594C6.07669 12.9321 5.5401 12.3955 4.87819 12.3955C4.21627 12.3955 3.67969 12.9321 3.67969 13.594C3.67969 14.2559 4.21627 14.7925 4.87819 14.7925Z",
    stroke: "url(#paint23_linear_458_784)",
    strokeWidth: 0.6375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_f_458_784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M12.3137 14.7925C12.9756 14.7925 13.5122 14.2559 13.5122 13.594C13.5122 12.9321 12.9756 12.3955 12.3137 12.3955C11.6518 12.3955 11.1152 12.9321 11.1152 13.594C11.1152 14.2559 11.6518 14.7925 12.3137 14.7925Z",
    stroke: "url(#paint24_linear_458_784)",
    strokeWidth: 0.6375
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_458_784",
    x: 1.07422,
    y: 6.5144,
    width: 6.75,
    height: 5.11851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.75,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.639216 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_458_784",
    x: 7.07422,
    y: 4.0144,
    width: 8.75,
    height: 7.12549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.784314 0 0 0 0 0.615686 0 0 0 0 0.258824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.756863 0 0 0 0 0.27451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_458_784",
    x: 11.4117,
    y: 12.9769,
    width: 1.575,
    height: 1.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0375,
    dy: -0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.364706 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0375,
    dy: 0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.764706 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_458_784",
    x: 10.478,
    y: 12.0288,
    width: 3.47119,
    height: 3.58345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.0823529 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.0313726 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_458_784",
    x: 11.5372,
    y: 13.0865,
    width: 1.35576,
    height: 1.35601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0375,
    dy: -0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.364706 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0375,
    dy: 0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.764706 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_458_784",
    x: 3.06445,
    y: 12.0288,
    width: 3.47119,
    height: 3.58345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.0823529 0 0 0 0 0.215686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.0313726 0 0 0 0 0.235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_458_784",
    x: 4.12266,
    y: 13.0865,
    width: 1.35576,
    height: 1.35601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0375,
    dy: -0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.478431 0 0 0 0 0.364706 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_458_784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0375,
    dy: 0.0375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.764706 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_458_784",
    result: "effect2_innerShadow_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_458_784",
    x: 2.79834,
    y: 11.5142,
    width: 4.15967,
    height: 4.15967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125,
    result: "effect1_foregroundBlur_458_784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_458_784",
    x: 10.2339,
    y: 11.5142,
    width: 4.15967,
    height: 4.15967,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125,
    result: "effect1_foregroundBlur_458_784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_784",
    x1: 1.73072,
    y1: 8.5364,
    x2: 7.44922,
    y2: 8.5364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9BDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDDF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_784",
    x1: 4.75072,
    y1: 6.4324,
    x2: 4.75072,
    y2: 6.8159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C6C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#C8C6C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_458_784",
    x1: 7.44922,
    y1: 8.4049,
    x2: 7.34622,
    y2: 8.4049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#604114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#604114",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_458_784",
    x1: 7.82972,
    y1: 11.0129,
    x2: 15.4492,
    y2: 6.79241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0B343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_458_784",
    x1: 11.4492,
    y1: 4.0144,
    x2: 11.4492,
    y2: 5.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAC439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC439",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_458_784",
    x1: 15.4492,
    y1: 8.0769,
    x2: 15.3047,
    y2: 8.0769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDBE7A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_458_784",
    x1: 5.168,
    y1: 7.45179,
    x2: 2.1365,
    y2: 10.0143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AD3F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_458_784",
    x1: 3.5265,
    y1: 7.01929,
    x2: 3.5265,
    y2: 8.93429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D95DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_458_784",
    x1: 5.656,
    y1: 8.77579,
    x2: 4.9415,
    y2: 8.77579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B8E6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_458_784",
    x1: 9.86422,
    y1: 10.512,
    x2: 9.88672,
    y2: 13.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_458_784",
    x1: 7.44922,
    y1: 11.807,
    x2: 7.99972,
    y2: 11.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#EA3A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3A0C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_458_784",
    x1: 11.4492,
    y1: 14.4495,
    x2: 11.4492,
    y2: 13.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC2447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_458_784",
    x1: 14.4481,
    y1: 11.7954,
    x2: 15.2461,
    y2: 12.7174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8166A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_458_784",
    x1: 4.44922,
    y1: 10.2954,
    x2: 4.44922,
    y2: 14.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_458_784",
    x1: 7.44922,
    y1: 12.3424,
    x2: 6.52722,
    y2: 12.3424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B3D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_458_784",
    x1: 4.44922,
    y1: 14.0194,
    x2: 4.44922,
    y2: 13.1704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC2447",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_458_784",
    x1: 7.44922,
    y1: 11.8479,
    x2: 7.34622,
    y2: 11.8479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC2303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC2303",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_458_784",
    x1: 4.79976,
    y1: 11.8079,
    x2: 4.79976,
    y2: 14.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99160C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC0819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_458_784",
    x1: 12.1992,
    y1: 11.8079,
    x2: 12.1992,
    y2: 14.0194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99160C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC0819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_458_784",
    x1: 11.4135,
    y1: 13.3278,
    x2: 14.02,
    y2: 13.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#34214F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241337"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_458_784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2135 13.6088) rotate(-65.5365) scale(0.946963 0.989068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#2D114D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1249",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_458_784",
    x1: 3.99945,
    y1: 13.3278,
    x2: 6.60645,
    y2: 13.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#34214F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241337"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_458_784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.79995 13.6088) rotate(-65.5365) scale(0.946963 0.989068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#2D114D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1249",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_458_784",
    x1: 5.53069,
    y1: 12.643,
    x2: 4.07519,
    y2: 14.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#615B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#615B6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#615B6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#615B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_458_784",
    x1: 12.9667,
    y1: 12.643,
    x2: 11.5107,
    y2: 14.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#615B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#615B6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#615B6B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#615B6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverIcon);
export default __webpack_public_path__ + "static/media/deliver_icon.71731a58d418bd73aacac1cd222a472d.svg";
export { ForwardRef as ReactComponent };